'use client';

import { useLocale } from "next-intl";
import useSWR from "swr";

const fetcher = async <T>(url: string): Promise<T> => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${process.env.NEXT_PUBLIC_TOKEN}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data. Please try again later.");
  }
};

interface Product {
  id: number;
  title_en: string;
  title_ar: string;
  title_fr: string;
  title_de: string;
  title_es: string;
  title_it: string;
  title_pt: string;
  title_nl: string;
  title_ru: string;
  title_sv: string;
  image_en: string;
  image_ar: string;
  image_fr: string;
  image_de: string;
  image_es: string;
  image_it: string;
  image_pt: string;
  image_nl: string;
  image_ru: string;
  image_sv: string;
  content_en: string;
  content_ar: string;
  content_fr: string;
  content_de: string;
  content_es: string;
  content_it: string;
  content_pt: string;
  content_nl: string;
  content_ru: string;
  content_sv: string;
  old_price:string;
  new_price:string;
  dropshippingID:string;
  instock:string;
}


const useFetchProducts = () => {
  const locale = useLocale();

  const { data, error, isLoading } = useSWR<Product[]>(
    [`${process.env.NEXT_PUBLIC_URL}product/`, locale],
    ([url]) => fetcher<Product[]>(url),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
      keepPreviousData: true,
    }
  );

  return { Products: data || [], error, isLoading: isLoading && !data };
};

export default useFetchProducts;